import HutritGreenIcon from '../../../../icons/HutritGreenIcon'
const Logo = ({ className = '', size = 'md' }) => {
  const heightClass = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10',
  }[size]
  return (
    <div
      className={`inline-flex items-center gap-2.5 font-bold tracking-tight select-none ${className}`}
    >
      <HutritGreenIcon
        className={`${heightClass} w-auto transition-transform duration-300 hover:scale-[1.02]`}
        fill="#00FF9D"
      />
    </div>
  )
}
export { Logo }
